// tslint:disable:no-any (autogenerated)
// tslint:disable:no-unsafe-any (autogenerated)
import BaseRequest from '../../components/base/base-request';
import {
    IActiveUserPermissionsData,
    ISettingsStoreSourcesStateUnparsedBackend,
    ISettingsStoreSourcesStateUnparsedFile
} from './settings-types';
// tslint:disable-next-line:no-var-requires no-require-imports (autogenerated)
const urls = require('../../bootstrap/updated/public-player-customize-helper').getSettingsSources();

class SettingsRequests extends BaseRequest {
    public async fetchSettings(
        sources: string[],
        host: string = '',
        lang?: string,
        jwt?: string
    ): Promise<ISettingsStoreSourcesStateUnparsedBackend> {
        return this.rawRequest(
            host + urls.fetchSettings,
            {
                lang,
                source: sources.join(','),
                format: 'json'
            },
            {
                type: 'GET',
                jwt
            }
        );
    }

    public async fetchPermissions(jwt?: string): Promise<IActiveUserPermissionsData> {
        return this.rawRequest<IActiveUserPermissionsData>(
            urls.fetchPermissions,
            {},
            {
                type: 'GET',
                jwt
            }
        );
    }

    public async fetchDefaultSettings(
        host: string = ''
    ): Promise<ISettingsStoreSourcesStateUnparsedFile> {
        if (typeof APP_DEFAULT_SETTINGS_b192a8f0 !== 'undefined') {
            return Promise.resolve(APP_DEFAULT_SETTINGS_b192a8f0 as ISettingsStoreSourcesStateUnparsedFile);
        }

        let url = urls.defaultSettings;
        if (url.indexOf('http') !== 0) {
            url = host + url;
        }
        return this.rawRequest(
            url,
            {},
            {
                type: 'GET',
                doNotUseCredentials: true
            }
        );
    }

    public async fetchCustomSettings(
        host: string = ''
    ): Promise<ISettingsStoreSourcesStateUnparsedFile> {
        if (typeof APP_CUSTOM_SETTINGS_b192a8f0 !== 'undefined') {
            return Promise.resolve(APP_CUSTOM_SETTINGS_b192a8f0 as ISettingsStoreSourcesStateUnparsedFile);
        }
        let url = urls.customSettings;
        if (url.indexOf('http') !== 0) {
            url = host + url;
        }
        return this.rawRequest(
            url,
            {},
            {
                type: 'GET',
                doNotUseCredentials: true
            }
        );
    }
}

const request = new SettingsRequests();
// tslint:disable-next-line:no-default-export (autogenerated)
export default request;
